import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=e76854fa"
import script from "./Attachments.vue?vue&type=script&lang=ts"
export * from "./Attachments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports